import { Component, OnInit, Inject } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NotesService } from '../../../services/notes.service';
import { NoteBoilerplatesCreateComponent } from './note-boilerplates-create/note-boilerplates-create.component';
import { MessagingService } from '../../../services/messaging.service';
import {PredefinedNoteSetDataModel} from '../../../models/notes/predefined-note-set-data.model';
import {PredefinedNoteDataModel} from '../../../models/notes/predefined-note-data.model';

@Component({
  selector: 'app-note-boilerplates',
  templateUrl: './note-boilerplates.component.html',
  styleUrls: ['./note-boilerplates.component.css']
})
export class NoteBoilerplatesComponent implements OnInit {

  note: string = '';
  contextPositionX = 0;
  contextPositionY = 0;
  notePreview: string = '';
  isSaving: boolean = false;
  isLoading: boolean = false;
  showContext: boolean = false;
  clickedEmptySpace: boolean = false;
  dataNoteSet: PredefinedNoteSetDataModel;
  activeContextNote: PredefinedNoteDataModel;
  disableContextActions: boolean = false;
  savePredefinedNoteTimeout: any = false;
  hasNoActiveContextNotes: boolean = false;
  activePredefinedNote: PredefinedNoteDataModel;

  constructor(
    public dialogRef: MatDialogRef<NoteBoilerplatesComponent>,
    public dialog: MatDialog,
    private messagingService: MessagingService,
    private notesService: NotesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.note = this.data.note;
    this.notePreview = `${this.note}`;
    this.init();
  }

  init() {
    this.isLoading = true;
    this.fetchBoilerplateNotes()
      .then((result: PredefinedNoteSetDataModel) => {
        this.dataNoteSet = result;
        this.filterNotes();
        this.orderNotes();
        this.isLoading = false;
      }, err => {
        this.isLoading = false;
        console.log('err', err);
        this.messagingService.sendComponentMessage('notesDisplayWarning', {
          message: 'Whoops... something went wrong'
        });
      });
  }

  filterNotes() {
    this.dataNoteSet.dataPredefinedNotes = this.dataNoteSet.dataPredefinedNotes
      .filter(note => note.xauditDeleted === false);
  }

  orderNotes() {
    this.dataNoteSet.dataPredefinedNotes = this.dataNoteSet.dataPredefinedNotes
      .sort((a, b) => a.NoteOrder - b.NoteOrder);
  }

  setNote() {
    this.note = this.notePreview;
  }

  resetNote() {
    this.notePreview = `${this.note}`;
  }

  onRightClickEvent(event, predefinedNote: PredefinedNoteDataModel, clickedEmptySpace: boolean) {
    this.contextPositionX = event.clientX;
    this.contextPositionY = event.clientY;
    this.clickedEmptySpace = clickedEmptySpace;
    if (predefinedNote) {
      this.activeContextNote = predefinedNote;
    } else {
      this.hasNoActiveContextNotes = true;
    }
    this.showContext = true;
  }

  selectPredefinedNote(predefinedNote: PredefinedNoteDataModel) {
    this.resetNote();
    if (this.note.length) {
      this.notePreview += `
`;
    }
    this.notePreview += `${predefinedNote.NoteTemplate}`;
    this.activePredefinedNote = predefinedNote;
  }

  fetchBoilerplateNotes() {
    const promise = new Promise((resolve, reject) => {
      this.notesService.getNoteBoilerplateSet()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  save() {
    this.note = this.notePreview;
    this.dialogRef.close(
      { note: this.note }
    );
  }

  hideContextMenu() {
    this.showContext = false;
  }

  drop(event: CdkDragDrop<PredefinedNoteDataModel[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
    this.saveAllPredefinedNotes(this.dataNoteSet.dataPredefinedNotes);
  }

  saveAllPredefinedNotes(predefinedNotes: PredefinedNoteDataModel[]) {
    this.isSaving = true;
    this.disableContextActions = true;

    if (this.savePredefinedNoteTimeout) {
      return;
    }

    this.savePredefinedNoteTimeout = setTimeout(_ => {
      let order = 0;
      this.dataNoteSet.dataPredefinedNotes.forEach(note => {
        order++;
        note.NoteOrder = order;
      });

      this.notesService.savePredefinedNotes(predefinedNotes)
        .subscribe((response: PredefinedNoteDataModel[]) => {
          this.savePredefinedNoteTimeout = false;
          this.dataNoteSet.dataPredefinedNotes = response;
          this.filterNotes();
          this.isSaving = false;
          this.disableContextActions = false;
          this.orderNotes();
          this.messagingService.sendComponentMessage('notesDisplaySuccess', {
            message: 'Changes have been saved'
          });
        }, err => {
          this.messagingService.sendComponentMessage('notesDisplayWarning', {
            message: 'Whoops... something went wrong'
          });
          this.isSaving = false;
          this.savePredefinedNoteTimeout = false;
          this.disableContextActions = false;
        });

    }, 2000);
  }

  handleAddNewEvent() {
    const newNote: PredefinedNoteDataModel = new PredefinedNoteDataModel();
    newNote.NoteSetId = this.dataNoteSet.NoteSetId;
    this.openNoteBoilerplateCreateDialog(newNote, true);
  }

  handleEditEvent() {
    this.openNoteBoilerplateCreateDialog(this.activeContextNote, false);
  }

  getLastNote() {
    if (this.dataNoteSet.dataPredefinedNotes.length) {
      return this.dataNoteSet.dataPredefinedNotes[this.dataNoteSet.dataPredefinedNotes.length];
    } else {
      return null;
    }
  }

  handleDeleteEvent() {
    this.showContext = false;
    let count = 0;
    let index = 0;
    this.dataNoteSet.dataPredefinedNotes.forEach(note => {
      if (note.PredefinedNoteId === this.activeContextNote.PredefinedNoteId) {
        note.xauditDeleted = true;
        index = count;
      }
      count++;
    });
    this.saveAllPredefinedNotes(JSON.parse(JSON.stringify(this.dataNoteSet.dataPredefinedNotes)));
    this.dataNoteSet.dataPredefinedNotes.splice(index, 1);
  }

  openNoteBoilerplateCreateDialog(noteContext: PredefinedNoteDataModel, isNew: boolean): void {
    this.showContext = false;
    const dialogRef = this.dialog.open(NoteBoilerplatesCreateComponent, {
      width: '550px',
      height: '375px',
      data: {
        predefinedNote: noteContext
      }
    });
    dialogRef.afterClosed().subscribe((result: PredefinedNoteDataModel) => {
      if (result) {
        const newNote: PredefinedNoteDataModel = result;
        if (isNew) {

          if (this.hasNoActiveContextNotes) {
            newNote.NoteOrder = 1;
          } else {
            newNote.NoteOrder = this.activeContextNote.NoteOrder++;
          }

          this.hasNoActiveContextNotes = false;
          this.dataNoteSet.dataPredefinedNotes.forEach(note => {
            if (note.NoteOrder >= newNote.NoteOrder) {
              note.NoteOrder++;
            }
          });
          this.dataNoteSet.dataPredefinedNotes.push(newNote);
        }
        this.orderNotes();
        this.saveAllPredefinedNotes(this.dataNoteSet.dataPredefinedNotes);
      }
    }, err => {
      this.messagingService.sendComponentMessage('notesDisplayWarning', {
        message: 'Whoops... something went wrong'
      });
      console.log(err);
    });
  }

}
